import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface LazySectionProps {
  children: React.ReactNode;
  className?: string;
  threshold?: number;
  delay?: number;
}
export function LazySection({
  children,
  className = '',
  threshold = 0.05,
  delay = 0
}: LazySectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: threshold
  });
  return <motion.div ref={ref} initial={{
    opacity: 0
  }} animate={isInView ? {
    opacity: 1
  } : {
    opacity: 0
  }} transition={{
    duration: 0.4,
    delay: delay / 1000,
    ease: 'easeOut'
  }} className={className} style={{
    willChange: 'opacity'
  }} data-id="element-179">
      {children}
    </motion.div>;
}